import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Toolbar from 'components/atoms/Toolbars/Toolbar/Toolbar';
import {rgba} from 'polished';
import utils from 'helpers/utils';

const StyledViewBar = styled(Toolbar)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--view-bar-background-color': props.theme.property(`palette.${props.$color}.main`),
      '--view-bar-text-color': props.theme.property(`palette.${props.$color}.contrastText`),
      '--view-bar-skeleton-background-color': rgba(props.theme.property(`palette.${props.$color}.contrastText`), props.theme.property('palette.action.disabledOpacity')),
      '--view-bar-action-button-color': props.theme.property(`palette.${props.$color}.contrastText`),
      '--view-bar-action-button-disabled-color': rgba(props.theme.property(`palette.${props.$color}.contrastText`), props.theme.property('palette.action.disabledOpacity')),
      '--view-bar-progress-background-color': props.theme.property(`palette.${props.$color}.contrastText`)
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  justify-content: center;
  height: fit-content;
  min-height: unset;
  gap: ${props => props.theme.layout('2sp')};

  background-color: ${props => props.$css.$var('--view-bar-background-color')};

  > .Typography {
    flex-grow: 1;
    width: 1px;
    max-width: fit-content;
    
    &.Typography, * {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  .Typography {
    color: ${props => props.$css.$var('--view-bar-text-color', false)} !important;
    
    &.Skeleton {
      color: rgba(0, 0, 0, 0) !important;
      background-color: ${props => props.$css.$var('--view-bar-skeleton-background-color', false)} !important;
    }
  }
  
  .ViewBar {
    &-actions {
      display: flex;
      align-items: center;
      gap: ${props => props.theme.layout('0.5sp')};
      
      .Button {
        border-radius: ${props => props.theme.radius(0)};
        color: ${props => props.$css.$var('--view-bar-action-button-color', false)} !important;
        &.Button.Button-text.Button-disabled {
          color: ${props => props.$css.$var('--view-bar-action-button-disabled-color', false)} !important;
        }
      }
    }
    
    &-progress {
      display: flex;
      align-items: center;
      gap: ${props => props.theme.layout('1sp')};

      .Typography {
        font-size: ${props => props.theme.fontSize(10)};
      }

      .LinearProgress {
        width: ${props => props.theme.layout(40)};

        .MuiLinearProgress-bar {
          background-color: ${props => props.$css.$var('--view-bar-progress-background-color', false)} !important;
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledViewBar.propTypes = {
  theme: PropTypes.object
};

export default StyledViewBar;
